import React, { useEffect } from "react";
import { Redirect, Route } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
function PrivateRoute({ component: Component, authed, ...rest }) {
  const { isLoggedIn, user, loading } = useAuth();
  const history = useHistory();
  useEffect(() => {
    if (!isLoggedIn || !user) {
      history.push("/");
    }
  }, [history, isLoggedIn, user]);
  if (loading) return <div>Loading...</div>;

  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/signin", state: { from: props.location } }}
          />
        )
      }
    />
  );
}
export default PrivateRoute;
